import styled from "styled-components";
import {FormControl} from "@mui/material";

export const FormField = styled(FormControl)`
	&.MuiFormControl-root {
		width: 100%;
		margin-bottom: 12px;
	}
`;
